export default __webpack_public_path__ + "static/media/Icono12.3fd1500b.svg";